import React, { useState, useRef, useEffect } from "react";
import { FaBars } from "react-icons/fa";
import { BellDot, LogOut, User, Settings, UserCircle } from "lucide-react";
import { Link } from "react-router-dom";
import "./Header.css";
import "./header-fix.css";
import { useAuth } from "../Context/authContext";

const Header = ({ isSidebarOpen, toggleSidebar }) => {
  const { user, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showSettingsDropdown, setShowSettingsDropdown] = useState(false);
  const settingsDropdownRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
      if (
        settingsDropdownRef.current &&
        !settingsDropdownRef.current.contains(event.target)
      ) {
        setShowSettingsDropdown(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const toggleSettingsDropdown = () => {
    setShowSettingsDropdown((prev) => !prev);
  };

  const toggleDropdown = () => {
    setShowDropdown((prev) => {
      console.log("Toggle dropdown, new state:", !prev);
      return !prev;
    });
  };

  // Check if dropdown is visible on render
  useEffect(() => {
    console.log("Dropdown visibility state:", showDropdown);
  }, [showDropdown]);

  return (
    <header className="header py-2 px-3 bg-white shadow-sm">
      <div className="header-left">
        <FaBars className="menu-icon" onClick={toggleSidebar} />
        <div className="main-heading">
         <img src="/VAR80.svg" className="img-fluid"></img>
        </div>
      </div>

      <div className="header-right">
        <div className="header-icons-section">
        <div className="settings-dropdown-wrapper" ref={settingsDropdownRef}>
  <img
    src="/setting.svg"
    className="header-icon"
    title="Setting"
    alt="Setting"
    onClick={toggleSettingsDropdown}
  />
  {showSettingsDropdown && (
    <div className="settings-dropdown-menu">
        <Link to="/company-management" className="dropdown-item">
        Company Management
      </Link> <div className="dropdown-divider"></div>
      <Link to="/accountbilling" className="dropdown-item">
      Account & Billing
      </Link>
    </div>
  )}
</div>


          <img
            src="/creativity.svg"
            className="header-icon"
            title="Creativity"
            alt="Creativity"
          />
        </div>

        <div className="header-auth-section">
          <div className="notification-badge">
            <BellDot className="header-icon" title="Notifications" />
            <span className="badge">3</span>
          </div>

          {user ? (
            <div className="profile-dropdown" ref={dropdownRef}>
              <div className="profile-trigger" onClick={toggleDropdown}>
                <UserCircle size={40} className="default-avatar" />
                {/* Indicator to show dropdown state */}
                <span style={{ display: 'none' }}>{showDropdown ? 'open' : 'closed'}</span>
              </div>

              {showDropdown && (
                <div 
                  className="dropdown-menu" 
                  style={{ 
                    display: 'block',
                    position: 'absolute',
                    right: '0',
                    left: 'auto',
                    transform: 'none'
                  }}
                >
                  <div className="dropdown-header">
                    <UserCircle size={48} className="me-2" />
                    <div>
                      <h6 className="mb-0">{user.email}</h6>
                      <small className="text-muted">Free Account</small>
                    </div>
                  </div>
                  <div className="dropdown-divider"></div>
                  <Link to="/profile" className="dropdown-item">
                    <User size={18} className="me-2" />
                    My Profile
                  </Link>
                  <Link to="/settings" className="dropdown-item">
                    <Settings size={18} className="me-2" />
                    Settings
                  </Link>
                  <div className="dropdown-divider"></div>
                  <button
                    onClick={logout}
                    className="dropdown-item text-danger"
                  >
                    <LogOut size={18} className="me-2" />
                    Logout
                  </button>
                </div>
              )}
            </div>
          ) : (
            <Link to="/login" className="login-button">
              Login
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
